import { testimonials } from "@/mocks/manga";

const pillars = [
  { icon: "ri-progress-4-line", title: "追更进度条", desc: "每部连载实时同步阅读位置，跨设备接着读，长期连载不怕断。" },
  { icon: "ri-bar-chart-line", title: "热门榜单", desc: "周榜、月榜、总榜每日刷新，霸榜作品第一时间精准追踪。" },
  { icon: "ri-shield-check-line", title: "稳定周更", desc: "优先收录固定更新时间的长篇连载，休刊自动提醒不误追。" },
];

export default function About() {
  return (
    <section id="about" className="bg-background-100/70">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:items-center">
          <div>
            <p className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-sm font-medium text-primary-800">
              <i className="ri-user-heart-line"></i>
              关于我们
            </p>
            <h2 className="mt-3 font-heading text-2xl text-foreground-950 md:text-4xl">
              番木瓜漫画，是追更人的快乐源泉
            </h2>
            <p className="mt-4 leading-relaxed text-foreground-700">
              番木瓜漫画是一站式国漫追更平台，专注收录人气连载、周更作品与霸榜作品。我们相信，一部真正好看的长篇连载，不该因为「忘了追到哪」而被错过。
            </p>
            <p className="mt-3 leading-relaxed text-foreground-700">
              为此我们做了追更进度条、每日刷新的热门榜单，以及可靠的更新追踪。点开即知最新话进度，让每一份等待都有回应。
            </p>
            <div className="mt-6 space-y-4">
              {pillars.map((p) => (
                <div key={p.title} className="flex items-start gap-3">
                  <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                    <i className={`${p.icon} text-lg`}></i>
                  </span>
                  <div>
                    <h3 className="font-medium text-foreground-950">{p.title}</h3>
                    <p className="mt-0.5 text-sm text-foreground-700">{p.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            <div className="rounded-xl bg-primary-500 p-6 text-background-50">
              <p className="font-heading text-3xl">4.8万+</p>
              <p className="mt-1 text-sm text-background-100/90">正在收录的连载作品</p>
            </div>
            <div className="rounded-xl bg-accent-500 p-6 text-foreground-950">
              <p className="font-heading text-3xl">960万+</p>
              <p className="mt-1 text-sm text-foreground-900/80">使用追更进度条的读者</p>
            </div>
            <div className="rounded-xl bg-secondary-500 p-6 text-background-50">
              <p className="font-heading text-3xl">99.2%</p>
              <p className="mt-1 text-sm text-background-100/90">周更作品的更新准时率</p>
            </div>
            <div className="rounded-xl bg-foreground-900 p-6 text-background-50">
              <p className="font-heading text-3xl">全天候</p>
              <p className="mt-1 text-sm text-background-100/90">榜单与进度实时同步</p>
            </div>
          </div>
        </div>

        <div className="mt-16">
          <div className="text-center">
            <h3 className="font-heading text-2xl text-foreground-950 md:text-3xl">追更读者怎么说</h3>
          </div>
          <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-3">
            {testimonials.map((t) => (
              <figure
                key={t.name}
                className="rounded-xl bg-background-50 p-6 ring-1 ring-background-200/70"
              >
                <div className="flex text-accent-500">
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                </div>
                <blockquote className="mt-3 text-sm leading-relaxed text-foreground-700">
                  “{t.text}”
                </blockquote>
                <figcaption className="mt-4 flex items-center gap-3">
                  <img
                    src={t.avatar}
                    alt={`${t.name} 头像`}
                    className="h-10 w-10 rounded-full object-cover"
                  />
                  <div>
                    <p className="text-sm font-medium text-foreground-950">{t.name}</p>
                    <p className="text-xs text-foreground-600">{t.role}</p>
                  </div>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}